import React from "react";
import { Helmet } from "react-helmet";
import UpdateLead from "./updateLeadForm";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/newLeadSidebarMenu";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";


const UpdateLeadData = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Update Lead</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <UpdateLead />
                </div>
            </div>
        </div>
        
    );
}

export default UpdateLeadData;
